import { faStarSharp } from '@fortawesome/sharp-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@mui/material/Typography'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import { useAnalytics } from '../../../context/Analytics'
import useBasePath from '../../../hooks/useBasePath'
import { colors } from '../../../theme/colors'

interface RatingProps {
  id: string
  starRating: string
  numberOfReviews: string
  logoImageSrc: string
  altText: string
  href: string
  ctaName?: string
}

const Rating: FC<RatingProps> = ({
  id,
  starRating,
  numberOfReviews,
  logoImageSrc,
  altText,
  href,
  ctaName,
}) => {
  const withBasePath = useBasePath()
  const { track, events } = useAnalytics()

  return (
    <Link
      id={id}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-labelledby={id}
      className="no-underline"
      onClick={() =>
        track?.(events.INTERACTION.ClickCta, {
          ...(ctaName ? { cta: ctaName } : {}),
        })
      }
    >
      <div className="flex flex-col gap-2 items-center lg:items-start">
        <div className="flex flex-row md:gap-2 items-center">
          <Typography variant="h3" sx={{ color: 'white' }}>
            {starRating}
          </Typography>
          <Typography variant="h4" sx={{ color: colors.Green[600] }} className="lg:hidden">
            <FontAwesomeIcon icon={faStarSharp} />
          </Typography>
          <Typography variant="h4" sx={{ color: colors.Green[100] }} className="hidden lg:block">
            <FontAwesomeIcon icon={faStarSharp} />
          </Typography>
        </div>
        <div className="relative h-[26px] w-[100px]">
          <Image src={withBasePath(logoImageSrc)} alt={altText} fill />
        </div>
        <Typography variant="p3" sx={{ color: colors.Green[200] }}>
          {numberOfReviews} reviews
        </Typography>
      </div>
    </Link>
  )
}

export default Rating
